import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { PartyPopper, Users } from "lucide-react";

export function WelcomeInviteButton({ user, testid, compact }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (compact && !window.confirm(`Inviare l'email di benvenuto a ${user.email}?`)) return;
    setBusy(true);
    try { await api.post(`/users/${user.id}/send-welcome`); toast.success(`Invito di benvenuto inviato a ${user.email}`); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore invio"); }
    finally { setBusy(false); }
  };
  if (compact) return (
    <Button size="icon" variant="outline" className="h-9 w-9 shrink-0" disabled={busy} onClick={send} title="Invia benvenuto" aria-label="Invia benvenuto" data-testid={testid || `send-welcome-${user.id}`}>
      <PartyPopper className="w-4 h-4" />
    </Button>
  );
  return (
    <Button size="sm" variant="outline" className="gap-1" disabled={busy} onClick={send} data-testid={testid || `send-welcome-${user.id}`}>
      <PartyPopper className="w-3.5 h-3.5" /> Invia benvenuto
    </Button>
  );
}

export function WelcomeInviteAll() {
  const [pending, setPending] = useState(0);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/network/welcome-pending").then((r) => setPending(r.data.pending)).catch(() => {});
  useEffect(() => { load(); }, []);
  const sendAll = async () => {
    if (!window.confirm(`Inviare l'email di benvenuto a ${pending} dealer importati che non sono ancora entrati?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/network/send-welcome-all");
      toast.success(`Inviti inviati: ${data.sent}` + (data.skipped_recent ? ` · già invitati nelle ultime 24 ore: ${data.skipped_recent}` : "") + (data.failed ? ` · non riusciti: ${data.failed}` : ""));
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore invio"); }
    finally { setBusy(false); }
  };
  if (!pending) return null;
  return (
    <Button variant="outline" className="gap-1" disabled={busy} onClick={sendAll} data-testid="welcome-invite-all">
      <Users className="w-4 h-4" /> Invita i non entrati (<span data-testid="welcome-pending-count">{pending}</span>)
    </Button>
  );
}
